export default {
  SET_FILTERS(state, obj) {
    state[obj.routeName] = obj.filters
  },
  // SET_ALL_FILTERS(state, obj) {
  //   // state.assign(obj)
  // },
}
